<template>
  <section class="root" ref="top">
    <div class="grid-flow">
      <div class="filter-bar" v-if="blok.show_filter">
        <input type="search" v-model="search_term" :placeholder="`${$gettext('Search')}...`">
        <!-- <cms-select :options="datesRanges" :default-text="$gettext('Most Recent')" :value="date_filter" @input="fetchDateFiltered($event)"></cms-select> -->
      </div>
      <cms-loading v-show="busy"></cms-loading>
      <p v-if="list.length == 0 && !busy" class="zero grid-spread">
        <translate>Sorry, no blog posts found.</translate>
      </p>
      <router-link class="blog accent-hover" :key="b.id" v-for="b in list" :to="generateLink(b)" v-show="!busy">
        <img :src="transformImage(b.content?.image?.filename, '340x190', true)" :alt="b.name">
        <div class="content">
          <p class="title">{{ b.content.title }}</p>
          <p class="author">
            <span class="no-author-img" v-if="!b.content.meta[0].picture?.filename">{{
              authorInitials(b.content.meta[0].name
              ) }}</span>
            <img v-if="b.content.meta[0].picture?.filename"
              :src="transformImage(b.content.meta[0]?.picture?.filename, '100x100', true)" alt="">
            <span>{{ b.content.meta[0].name }} - {{ postDate(b.first_published_at) }}</span>
          </p>
        </div>
      </router-link>
    </div>
    <cms-pagination v-show="!busy" :total-count="totalBlogs" :per-page="blok.max || '24'" :current-page="page" @goto:page="gotoPage" />
  </section>
</template>

<script>
import cms, { loads } from "@/mixins/cms.js";
export default {
  mixins: [cms, loads],
  name: "cms-blog-list",
  data() {
    return {
      dates: [],
      start: null,
      end: null,
      date_filter: [],
      page: 1,
      totalBlogs: 0,
      search_term: null
    }
  },
  watch: {
    search_term(n) {
      const debounced = this.debounce(() => {
        this.fetchBlogs(false)
      }, 500);
      this.page = 1;
      n == "" ? this.fetchBlogs(false) : debounced()
    },
    blok() {
      this.fetchBlogs();
    }
  },
  async fetch() {
    await this.fetchBlogs()
  },
  computed: {
    datesRanges() {
      const entries = []
      const lang = this.$language.current.replace("en", "en-GB");
      const unix = new Set();

      this.dates.forEach(d => {
        const start = new Date(d.getFullYear(), d.getMonth(), 1)
        unix.add(start.getTime())
      })

      unix.forEach(v => {
        const format = new Intl.DateTimeFormat(lang, { dateStyle: 'long' }).format(new Date(v)).split(" ");
        format.shift(); // Remove day value
        entries.push({ name: format.join(" "), value: v })
      })

      return entries
    }
  },
  methods: {
    authorInitials(a) {
      if (!a) {
        return "N/A"
      }
      return a.charAt(0)
    },
    gotoPage(p) {
      this.page = p;
      this.fetchBlogs(false);
      if (process.client) {
        window.scrollTo({
          top: this.$refs.top.offsetTop - 85,
          behavior: 'smooth',
        })
      }
    },
    fetchDateFiltered(e) {
      this.date_filter = e
      if (this.date_filter[0]) {
        const startRange = new Date(parseInt(this.date_filter[0]))
        const endRage = new Date(startRange.getFullYear(), startRange.getMonth() + 1, 0);
        this.start = startRange.toLocaleDateString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit" }).split("/").reverse().join("-") + " 00:00"
        this.end = endRage.toLocaleDateString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit" }).split("/").reverse().join("-") + " 23:59"
      } else {
        this.start = null;
        this.end = null;
      }
      this.page = 1;
      this.fetchBlogs(false)
    },
    async fetchBlogs(updateDates = true) {
      this.busy = true;
      const lang = this.$language.current.replace("de", "de_CH").replace("en", "");
      const options = {
        search_term: this.blok.search || this.search_term || null,
        sort_by: "first_published_at:desc",
        first_published_at_gt: this.blok.from || this.start || null,
        first_published_at_lt: this.blok.to || this.end || null,
        version: this.$config.STORYBLOK_VERSION,
        page: this.page,
        per_page: this.blok.max || 24,
        starts_with: lang ? `${lang}/blog` : `blog`,
        // with_tag: "Audi Abo",
      };
      const { data, total } = await this.$sb.get(`cdn/stories/`, options);
      this.totalBlogs = total;
      this.list = data.stories;
      if (updateDates) {
        this.dates = this.list.map(b => new Date(b.published_at))
      }
      this.busy = false;
    },
    postDate(d) {
      const date = new Date(d);
      return date.toLocaleDateString();
    },
    generateLink(blog) {
      return `/${this.$language.current}/blog/${blog.slug}`
    }
  },

}
</script>

<style scoped>
div.grid-flow {
  --flow-width: 160px;
}

div.filter-bar {
  grid-column: 1/-1;
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

p.zero {
  font-style: italic;
  font-size: 0.9rem;
  text-align: center;
  color: var(--crf-mute);
}

a.blog {
  overflow: hidden;
  display: grid;
  grid-template-rows: min-content 1fr;
  text-decoration: none;
  color: var(--crf-text);
  border-radius: 8px;
  background-color: var(--crf-bg-high);
  box-shadow: var(--crf-shadow);
}

p.title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--crf-flip);
}

span.no-author-img {
  overflow: hidden;
  display: grid;
  place-items: center;
  text-transform: uppercase;
  color: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 0.7rem;
  background-color: var(--crf-accent);
}

p.author {
  margin-top: auto;
  margin-bottom: 0;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 5px;
}

p.author img {
  border-radius: 50%;
  aspect-ratio: 1/1;
  width: 30px;
  height: 30px;
}

img {
  width: 100%;
  aspect-ratio: 16/9;
  display: block;
  object-fit: cover;
}

div.content {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
}

input {
  margin: 0;
  padding: 8px 10px;
  font-size: 0.9rem;
  border-radius: 6px;
  outline: none;
  border: none;
  color: var(--crf-flip);
  background-color: var(--crf-bg-high);
  box-shadow: var(--crf-shadow);
  resize: none;

}

input:focus {
  outline: 1px solid var(--crf-accent)
}

@media screen and (min-width: 582px) {
  div.filter-bar {
    flex-direction: row;
  }

  div.filter-bar input {
    /* flex: 0 0 74.5%; */
    flex-grow: 1;
  }

  div.grid-flow {
    --flow-width: 200px;
  }
}
</style>
